/** Подстроковый поиск без учёта регистра; пустой запрос — все строки проходят. */
export function matchesListSearch(
  query: string,
  ...fields: (string | number | undefined | null)[]
): boolean {
  const needle = query.trim().toLowerCase()
  if (!needle) return true
  for (const f of fields) {
    if (f == null || f === '') continue
    if (String(f).toLowerCase().includes(needle)) return true
  }
  return false
}
